export const getTotalCharCount = (stringArray: string[]) => {
    let charCount = 0;
    stringArray.forEach(paragraph => charCount += paragraph.length);
    return charCount;
}